import { SensorPayloadData } from 'pages/reporting/reports/rug/rugReportData'
import {
  GeckoFormattingVariant,
  GeckoMeasurement,
  GeckoMeasurementUnit,
} from 'types'
import { joinUniqueDisplayValues } from 'utils/stringHelpers'

interface GetSensorPayloadStringsParams {
  payloads: SensorPayloadData[] | undefined
  formatMeasurement: (params: {
    measurement: GeckoMeasurement | undefined
    variant?: GeckoFormattingVariant | 'none'
    showLoading?: boolean
    minimumFractionDigits?: number
    maximumFractionDigits?: number
  }) => string | undefined
}

interface SensorPayloadStrings {
  payloadTypesStr: string | undefined
  sensorFrequenciesStr: string | undefined
  sensorDiametersStr: string | undefined
}

export const getSensorPayloadStrings = ({
  payloads,
  formatMeasurement,
}: GetSensorPayloadStringsParams): SensorPayloadStrings => {
  const safePayloads = payloads ?? []

  const payloadTypesStr = joinUniqueDisplayValues(
    safePayloads.map((payload) => payload.payloadType)
  )

  const sensorFrequenciesStr = joinUniqueDisplayValues(
    safePayloads.map((payload) =>
      payload.sensorFrequency !== undefined
        ? `${payload.sensorFrequency} MHz`
        : undefined
    )
  )

  const sensorDiametersStr = joinUniqueDisplayValues(
    safePayloads.map((payload) => {
      if (payload.sensorDiameter?.value === undefined) {
        return undefined
      }

      return formatMeasurement({
        measurement: GeckoMeasurement.CreateFromValue(
          payload.sensorDiameter.value,
          GeckoMeasurementUnit.GetOrCreate(payload.sensorDiameter.unit)
        ),
        variant: 'narrow',
        minimumFractionDigits: 2,
        maximumFractionDigits: 3,
      })
    })
  )

  return {
    payloadTypesStr,
    sensorFrequenciesStr,
    sensorDiametersStr,
  }
}
